import { FC } from 'react'

import { LoadingSpinner } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { ProductReviewsContainer } from '../../../../../containers/ProductReviewsContainer'
import { ReviewsProductGroupDataService } from '../../../../../containers/ReviewsProductGroupDataService'

import { LoadingMessage, LoadingWrapper } from './styles'

export const ProductReviewsLoadingIndicator: FC = () => {
  const {
    magnolia: {
      reviewsPage: { loadingInProgress },
    },
    loadMoreButton: { loading: loadingLabel },
  } = useTranslation()

  const { status: productGroupDataStatus } = ReviewsProductGroupDataService.useContainer()
  const { status: reviewsStatus } = ProductReviewsContainer.useContainer()

  const isResolvedOrRejected =
    (productGroupDataStatus === 'resolved' || productGroupDataStatus === 'rejected') &&
    (reviewsStatus === 'resolved' || reviewsStatus === 'rejected')

  if (isResolvedOrRejected) return null

  return (
    <LoadingWrapper>
      <LoadingSpinner label={loadingLabel} size='20px' />
      <LoadingMessage $isUppercase>{loadingInProgress}</LoadingMessage>
    </LoadingWrapper>
  )
}
